import { type ComponentProps } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Config } from '../constants';

interface LinkProps extends ComponentProps<typeof RouterLink> {
  useRedirect?: boolean;
}

function Link(props: LinkProps) {
  if (typeof props.to !== 'string') return null;
  const url = new URL(props.to, window.location.origin);
  const isExternalLink = url.origin !== window.location.origin;

  if (isExternalLink || Config.singleLoadPage || props.useRedirect) {
    const { useRedirect, ref, to, ...anchorProps } = props;
    return (
      <a
        {...anchorProps}
        href={to.toString()}
        ref={ref}
        onClick={e => props.onClick?.(e)}
      >
        {props.children}
      </a>
    );
  }
  return (
    <RouterLink
      {...props}
      ref={props.ref}
      onClick={e => {
        if (window._wbUpdate) window.location.pathname = props.to.toString();
        if (props.onClick) props.onClick(e);
      }}
    />
  );
}

export default Link;
